

























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class DataTable extends Vue {
	@Prop(String)
	public displayError?: string;
}
